import { Injectable, ViewChild } from "@angular/core";
import {
  HttpClient,
  HttpParams,
  HttpRequest,
  HttpHeaders
} from "@angular/common/http";
import { Building } from "../building.model";
import { Observable } from "rxjs/Observable";
import { BehaviorSubject } from "rxjs";
import swal from "sweetalert2";
import { forkJoin } from "rxjs"; // RxJS 6 syntax
import { Router } from "@angular/router";
@Injectable({ providedIn: "root" })
export class DataService {
  id: number;

  formData: Building;

  list: Building[];

  options: any;

  private url = "http://honadon.uz/";

  private messageSource = new BehaviorSubject(null);

  private price = new BehaviorSubject(null);

  private sortByAll: BehaviorSubject<any[]> = new BehaviorSubject<any>([]);

  private buildingType: BehaviorSubject<any[]> = new BehaviorSubject<any>([]);

  private bed = new BehaviorSubject(null);

  currentMessage = this.messageSource.asObservable();

  filterPrice = this.price.asObservable();

  filterbed = this.bed.asObservable();

  filterByAll = this.sortByAll.asObservable();

  filterbuildingType = this.buildingType.asObservable();

  constructor(private http: HttpClient, private router: Router) {}

  changeMessage(message: string) {
    console.log("message:" + message);
    this.messageSource.next(message);
  }

  changePrice(price: string) {
    console.log("price:" + price);
    this.price.next(price);
  }
  changeBed(bed: number) {
    console.log("bed:" + bed);
    this.bed.next(bed);
  }
  changebuildingType(buildingType) {
    console.log("buildtypedataservice:" + buildingType);
    this.buildingType.next(buildingType);
  }
  changeSortByAll(rentsell) {
    console.log("sortbyalldataservice:" + rentsell);
    this.sortByAll.next(rentsell);
  }

  getMoneyType(): Observable<any> {
    return this.http.get(this.url + "api/MoneyType/GetList");
  }

  getRegion(): Observable<any> {
    return this.http.get(this.url + "api/Region/GetList");
  }
  getBuildTypeGroup(): Observable<any> {
    return this.http.get(this.url + "api/BuildTypeGroup/GetList");
  }

  getBuildType(id: number): Observable<any> {
    return this.http.get(
      this.url + "api/BuildType/GetByBuildTypeGroupId/" + id
    );
  }
  getSizeType(): Observable<any> {
    return this.http.get(this.url + "api/SizeName/GetList");
  }
  getBuildAction(): Observable<any> {
    return this.http.get(this.url + "api/BuildAction/GetList");
  }
  getDistrict(id): Observable<any> {
    return this.http.get(this.url + "api/District/GetByRegionId/" + id);
  }
  getMetro(id): Observable<any> {
    return this.http.get(this.url + "api/MetroKey/GetByDistrictId/" + id);
  }
  getZone(id): Observable<any> {
    return this.http.get(this.url + "api/Zone/GetByDistrictId/" + id);
  }

  getOutdoorAmenity(): Observable<any> {
    return this.http.get(this.url + "api/OutdoorAmenity/GetList");
  }
  getCountry(): Observable<any> {
    return this.http.get(this.url + "api/Country/GetList");
  }

  getAppliances(): Observable<any> {
    return this.http.get(this.url + "api/Appliance/GetList");
  }

  getBuildTech(): Observable<any> {
    console.log("getBuildTEch");
    return this.http.get(this.url + "api/BuildTechnology/GetList/");
  }

  getExterior(): Observable<any> {
    return this.http.get(this.url + "api/Exterior/GetList");
  }

  getIndoorFeature(): Observable<any> {
    return this.http.get(this.url + "api/IndoorFeature/GetList");
  }

  getCoolingType(): Observable<any> {
    return this.http.get(this.url + "api/CoolingType/GetList");
  }

  getHeatingFuel(): Observable<any> {
    return this.http.get(this.url + "api/HeatingFuel/GetList");
  }

  getFloorCovering(): Observable<any> {
    return this.http.get(this.url + "api/FloorCovering/GetList");
  }

  getRoofType(): Observable<any> {
    return this.http.get(this.url + "api/RoofType/GetList");
  }

  getRooms(): Observable<any> {
    return this.http.get(this.url + "api/Room/Get");
  }

  getView(): Observable<any> {
    return this.http.get(this.url + "api/View/GetList");
  }

  getClientType(): Observable<any> {
    return this.http.get(this.url + "api/ClientType/GetList");
  }

  getHeatingType(): Observable<any> {
    return this.http.get(this.url + "api/HeatingType/GetList");
  }

  getBasement(): Observable<any> {
    return this.http.get(this.url + "api/Basement/GetList");
  }

  getArchitecturalStyle(): Observable<any> {
    return this.http.get(this.url + "api/ArchitecturalStyle/GetList");
  }

  getDetails(id: number) {
    return this.http.get(this.url + "api/Building/Details/" + id);
  }

  searchBuildings(name: any) {
    return this.http.post(this.url + "api/Building/Search", name);
  }

  getFormUrlEncoded(toConvert) {
    const formBody = [];
    for (const property in toConvert) {
      const encodedKey = encodeURIComponent(property);
      const encodedValue = encodeURIComponent(toConvert[property]);
      formBody.push(encodedKey + "=" + encodedValue);
    }
    return formBody.join("&");
  }

  createBuilding(form) {
    this.options = {
      headers: new HttpHeaders({
        Authorization: `Bearer ${localStorage.getItem("token")}`
      })
    };
    return this.http
      .post(this.url + "api/Building/Create", form, this.options)
      .subscribe(next => {
        const alt = swal.mixin({
          toast: true,
          showConfirmButton: false,
          position: "center"
        });

        alt({ type: "success", title: "Success", timer: 5000 });
        this.router.navigate(["/buy"]);
        console.log(next);
      });
  }

  upload(fileToUpload: FormData) {
    return this.http.post("/api/GOODS/uploadFile", fileToUpload, {});
  }

  updateBuilding(fileToUpload: any) {
    return this.http.put(this.url + "/put", fileToUpload);
  }

  deleteBuilding(id: number) {
    return this.http.delete(this.url + "/delete/" + id);
  }
  changeLang(lang: string) {
    return this.http.get(this.url + "api/Home/ChangeCulture/" + lang);
  }
}
